import mapper from "./mapper"

export const importedMapper = mapper

export default mapper
